import React, {useState, useMemo, useCallback, useRef, useEffect} from 'react';
import {emailConfig} from '@/config';
import {ByzzerTextTip} from '@byzzer/ui-components';
import './CustomerSupportLink.scss';

export function CustomerSupportLink({className, children = emailConfig.supportEmail, applyDefaultStyle = true, ...props}) {
    const [tipText, setTipText] = useState('');
    const timeoutRef = useRef(null);

    // Validate and sanitize email to prevent XSS
    const sanitizedEmail = useMemo(() => {
        const email = emailConfig.supportEmail;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (typeof email === 'string' && emailRegex.test(email)) {
            return email;
        }
        console.error('Invalid email configuration');
        return '';
    }, []);

    const handleClick = useCallback(async (e) => {
        if (!sanitizedEmail) return;
        
        try {
            await navigator.clipboard.writeText(sanitizedEmail);
            setTipText('Email copied!');
            
            // Clear any existing timeout
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
            
            timeoutRef.current = setTimeout(() => {
                setTipText('');
                timeoutRef.current = null;
            }, 2000);
        } catch (error) {
            console.error('Failed to copy email:', error);
        }
    }, [sanitizedEmail]);

    // Cleanup timeout on unmount
    useEffect(() => {
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);

    const linkClassName = [
        applyDefaultStyle ? 'customer-support-link' : '',
        className
    ].filter(Boolean).join(' ');
    
    const link = (
        <a 
            {...props} 
            className={linkClassName} 
            href={sanitizedEmail ? `mailto:${sanitizedEmail}` : '#'} 
            onClick={handleClick}
            rel="noopener noreferrer"
        >
            {children}
        </a>
    );

    return tipText ? (
    <div className='customer-support-link--tip-wrapper'>
        <ByzzerTextTip tip={tipText} tipLocation='top' >
            {link}
        </ByzzerTextTip>
    </div>
    ) : link;
}
